import React from 'react';

import { PageMoveFormTemplate, PageMoveFormTemplateProps } from './PageMoveFormTemplate';
import { ComboBoxParam, Form, SonForm, useForm } from '../../../../_lib/Form2';
import useRedirect from '../../../../hooks/useRedirect';

export type PageMoveFormProps = {
  form: SonForm<ComboBoxParam<'newParentPageId'>>;
} & Omit<PageMoveFormTemplateProps, 'newParentPageIdParam' | 'fetchState' | 'resetFetchState'>;

export function PageMoveForm({
  form,
  hasExplicitReadRestrictions,
  hasChildPages,
  readRestrictionsComparisonUrl,
}: PageMoveFormProps) {
  const [startRedirect] = useRedirect();
  const { formProps, params, fetchState, resetFetchState } = useForm({
    form,
    onSuccess: response => {
      if (response.data?.url) {
        startRedirect(response.data?.url);
      }
    },
  });

  return (
    <Form id="page-move-form" {...formProps}>
      <PageMoveFormTemplate
        hasExplicitReadRestrictions={hasExplicitReadRestrictions}
        hasChildPages={hasChildPages}
        readRestrictionsComparisonUrl={readRestrictionsComparisonUrl}
        newParentPageIdParam={params.getByName('newParentPageId')}
        fetchState={fetchState}
        resetFetchState={resetFetchState}
      />
    </Form>
  );
}
